module.exports = __webpack_public_path__ + "img/main5.b119bd86.png";